module.exports = __webpack_public_path__ + "static/img/icon cd help.51d86053.svg";